import { getAppApiRoutes } from "../../Global";
import ResponseModel from "../../models/ResponseModel";
import { apiPost } from "../apiClient";

class DeviceCategoryService {
  async getDeviceCategories(): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.deviceCategory.getDeviceCategories, { filter: {} });
  }
}

const service: DeviceCategoryService = new DeviceCategoryService();
export default service;
